import React from 'react';
import cn from 'classnames';
import styles from './CopyLinkBtn.module.scss';
import { CopyLinkIcon } from '@repo/icons';
import { useTextCopiedTimer } from '@repo/hooks';

export default function CopyLinkBtn({ link, onCopy }: { link: string; onCopy: () => void }) {
  const [linkCopied, copyLink] = useTextCopiedTimer(link, onCopy);

  return (
    <button
      className={cn(styles.copyLinkBtn, linkCopied && styles.copied)}
      onClick={copyLink}
      disabled={linkCopied}
    >
      <CopyLinkIcon color="textSecondary" /> <label />
    </button>
  );
}
